import { IResponse, consumer } from "@bemap/utils";
import { ICompany } from "@bemap/utils";

const ENDPOINT = '/companies';

export const getCompanies = async (): Promise<IResponse> => {
  try {
    return await consumer('GET', ENDPOINT);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const getCompanyById = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('GET', ENDPOINT, undefined, id);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const newCompany = async (payload: ICompany): Promise<IResponse> => {
  try {
    return await consumer('POST', ENDPOINT, payload);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const updateCompany = async (payload: ICompany): Promise<IResponse> => {
  try {
    return await consumer('PATCH', ENDPOINT, payload, payload.id);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const deleteCompany = async (id: number): Promise<IResponse> => {
  try {
    return await consumer('DELETE', ENDPOINT, undefined, id);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
}; 